import type { VehicleCreatePayload } from "@/customTypings/vehicle/Vehicle";
import type { VehicleDeletedRestoreAvailableConflict } from "@/utils/vehicle/vehicleCreateConflict";
import {
    VEHICLE_CREATE_CONFLICT,
    VehicleCreateConflictError,
    isVehicleDeletedRestoreAvailableConflict,
} from "@/utils/vehicle/vehicleCreateConflict";
import { createPayloadSpreadRestoreConfig } from "./createPayloadSpreadRestoreConfig";

export function createVehicleRestoreConfig<TDetail extends { id: string }>(options: {
    restoreDeletedWithCreateValues: (payload: VehicleCreatePayload & { id: string }) => Promise<TDetail>;
    onRestored: (detail: TDetail) => void;
}) {
    return createPayloadSpreadRestoreConfig<
        VehicleDeletedRestoreAvailableConflict,
        VehicleCreatePayload,
        VehicleCreatePayload & { id: string },
        TDetail,
        VehicleCreateConflictError
    >({
        ConflictErrorClass: VehicleCreateConflictError,
        isRestoreAvailable: isVehicleDeletedRestoreAvailableConflict,
        deletedRestoreAvailableCode: VEHICLE_CREATE_CONFLICT.deletedRestoreAvailable,
        modalTitle: "Restore deleted vehicle?",
        modalBody: () =>
            "A deleted vehicle with this registration already exists. Restore it using the details you entered?",
        successLabel: (conflict) => conflict.existingRegistration,
        restoreDeletedWithCreateValues: options.restoreDeletedWithCreateValues,
        onRestored: (detail) => options.onRestored(detail),
    });
}
